<label class="form-label fw-bold mt-1">
  <app-red-asterisk *ngIf="isRequired"></app-red-asterisk>
  {{ labelText }}
</label>
